import React, { lazy } from 'react';
import MainLayout from 'layout/MainLayout';
import AuthGuard from 'component/Auth/AuthGuard';
import Loadable from 'component/Loadable';

const DashboardDefault = Loadable(lazy(() => import('views/Dashboard/Default')));
const LeadManagement = Loadable(lazy(() => import('views/LeadManagement')));
const SubscriptionManagement = Loadable(lazy(() => import('views/SubscriptionManagement')));
const ProductsAndServices = Loadable(lazy(() => import('views/ProductsAndServices')));
const ClientManagement = Loadable(lazy(() => import('views/ClientManagement')));


const Masters = Loadable(lazy(() => import('views/Masters')));
const Users = Loadable(lazy(() => import('views/Users')));
const Configuration = Loadable(lazy(() => import('views/Configuration')));
const AuditAndLog = Loadable(lazy(() => import('views/AuditAndLog')));




const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/dashboard/default',
            element: <DashboardDefault />,
        },
	{
	    path: '/leadmanagement/*',
	     element: <LeadManagement />,
	},
	{
            path: '/subscriptionmanagement/*',
            element: <SubscriptionManagement />,
        },
        {
            path: '/masters/*',
            element: <Masters />,
        },
	 {
            path: '/clientmanagement/*',
            element: <ClientManagement />,
         },
       {
            path: '/users/*',
            element: <Users />,
        },
	 {
            path: '/productsandservices/*',
            element: <ProductsAndServices />,
        },
        {
            path: '/configuration/*',
            element: <Configuration />,
        },
	{
            path: '/auditandlog/*',
            element: <AuditAndLog />,
        },
    ],
};

export default MainRoutes;
